const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';
export default API_URL;
